module.exports = __webpack_public_path__ + "media/images/icons/self-storage-icon-b45ab246ac293b81864ac568343728a9.png";